import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, Send } from "lucide-react";
import { AuthLayout } from "@/components/AuthLayout";
import { AUTH } from "@/constants/testIds";
import { api, formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Alert, AlertDescription } from "@/components/ui/alert";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setMessage("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setMessage(data?.message || "Check your email for reset instructions.");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      title="Forgot your password?"
      subtitle="Enter your account email and we'll send you a secure reset link."
      hint={<Link to="/login" className="font-semibold text-[#101876] hover:underline">Back to login</Link>}
    >
      <form onSubmit={submit} className="space-y-4" data-testid={AUTH.forgotRoot}>
        {error && <Alert variant="destructive"><AlertDescription>{error}</AlertDescription></Alert>}
        {message && (
          <Alert data-testid={AUTH.forgotSuccess} className="border-emerald-200 bg-emerald-50 text-emerald-800">
            <AlertDescription>{message}</AlertDescription>
          </Alert>
        )}
        <div className="space-y-1.5">
          <Label className="text-xs font-bold uppercase tracking-[0.15em] text-slate-500">Email</Label>
          <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid={AUTH.forgotEmail} />
        </div>
        <button
          type="submit"
          disabled={loading}
          className="inline-flex w-full items-center justify-center gap-2 rounded-md bg-[#101876] px-4 py-2.5 text-sm font-semibold text-white transition hover:bg-[#0c135c] disabled:opacity-70"
          data-testid={AUTH.forgotSubmit}
        >
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />}
          {loading ? "Sending…" : "Send reset link"}
        </button>
      </form>
    </AuthLayout>
  );
}
